module.exports = __webpack_public_path__ + "static/media/clock.7e20f012.svg";